/** @format */

import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";
import { colors } from "../../utility/types/constant";

export const StatsContainer = styled(Box)(({ theme }) => ({
	padding: "80px 20px",
	background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.thirdPrimary} 100%)`,
	position: "relative",
	overflow: "hidden",
	"&::before": {
		content: '""',
		position: "absolute",
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		background:
			"radial-gradient(circle at 30% 50%, rgba(255,255,255,0.05) 0%, transparent 50%)",
		pointerEvents: "none",
	},
	[theme.breakpoints.down("md")]: {
		padding: "60px 20px",
	},
}));

export const StatCard = styled(Box)(({ theme }) => ({
	textAlign: "center",
	position: "relative",
	padding: "30px 20px",
	borderRadius: "16px",
	backgroundColor: "rgba(255,255,255,0.05)",
	backdropFilter: "blur(10px)",
	border: "1px solid rgba(255,255,255,0.1)",
	transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
	"&:hover": {
		transform: "translateY(-10px) scale(1.05)",
		backgroundColor: "rgba(255,255,255,0.1)",
		boxShadow: "0 20px 40px rgba(0,0,0,0.3)",
	},
}));

export const PulseCircle = styled(Box)(({ theme }) => ({
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	width: "200px",
	height: "200px",
	borderRadius: "50%",
	background:
		"radial-gradient(circle, rgba(30,193,149,0.2) 0%, transparent 70%)",
	animation: "pulse 3s ease-in-out infinite",
	"@keyframes pulse": {
		"0%, 100%": {
			transform: "translate(-50%, -50%) scale(0.8)",
			opacity: 0.5,
		},
		"50%": {
			transform: "translate(-50%, -50%) scale(1.2)",
			opacity: 0.2,
		},
	},
}));

interface StatIconWrapperProps {
	bgColor: string;
}

export const StatIconWrapper = styled(Box, {
	shouldForwardProp: (prop) => prop !== "bgColor",
})<StatIconWrapperProps>(({ theme, bgColor }) => ({
	width: "80px",
	height: "80px",
	borderRadius: "50%",
	backgroundColor: bgColor,
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	margin: "0 auto 20px auto",
	color: "#ffffff",
	boxShadow: `0 8px 24px ${bgColor}40`,
	position: "relative",
	zIndex: 1,
}));

export const StatNumber = styled(Typography)(({ theme }) => ({
	fontFamily: "'Montserrat', sans-serif",
	fontSize: "clamp(2.5rem, 5vw, 4rem)",
	fontWeight: 900,
	color: "#ffffff",
	marginBottom: "8px",
	letterSpacing: "-0.02em",
	lineHeight: 1,
}));

export const StatLabel = styled(Typography)(({ theme }) => ({
	fontFamily: "'Montserrat', sans-serif",
	fontSize: "1rem",
	fontWeight: 500,
	color: "rgba(255,255,255,0.9)",
	lineHeight: 1.4,
}));
